module.exports = __webpack_public_path__ + "img/product_9.817d5bc.jpg";